module.exports = __webpack_public_path__ + "img/huaxizi.5cfa5d64.jpg";